import { redirect, useParams, useSearchParams } from "react-router";

import type { PATHS } from "@/routes/paths";
import { NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS } from "@/routes/paths";

import type { ParamParseKey } from "react-router";

export const useGetVoucherEditPageParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.MARKETING.VOUCHER.NEW>>();
	const [searchParams] = useSearchParams();

	const duplicateItemID = searchParams.get(NEW_ITEM_DUPLICATED_ITEM_ID_PARAMS);

	if (!hotelID) {
		redirect("/");
	}

	return { hotelID: hotelID!, duplicateItemID: duplicateItemID ?? undefined };
};
